import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
/**
 * get typography key value with token
 *
 * @example
 * ```ts
 * typographyProp('body1', 'fontSize')
 * ```
 */
function typographyProp(name, key) {
    if (name === 'inherit') {
        return undefined;
    }
    return function (_a) {
        var theme = _a.theme;
        var themeOfTypography = theme.typography[name];
        if (typeof themeOfTypography !== 'object') {
            throw new Error("Unexpected typography name: " + name);
        }
        return themeOfTypography[key];
    };
}
/**
 * get typography style from token
 *
 * @example
 * ```ts
 * typography('body1')
 * ```
 */
function typography(
/** name of token */
name, 
/** not contain `line-hight` style */
fontOnly) {
    if (fontOnly === void 0) { fontOnly = false; }
    var fontCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n  "], ["\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n  "])), typographyProp(name, 'fontSize'), typographyProp(name, 'fontWeight'), function (_a) {
        var theme = _a.theme;
        return theme.typography['fontFamily'];
    });
    return fontOnly
        ? fontCss
        : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        ", ";\n        line-height: ", ";\n      "], ["\n        ", ";\n        line-height: ", ";\n      "])), fontCss, typographyProp(name, 'lineHeight'));
}
export { typography, typographyProp };
var templateObject_1, templateObject_2;
